import React from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip'
import { emphasize } from '@mui/material/styles';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import ClearIcon from '@mui/icons-material/Clear';

function NoOptionsMessage(props) {
  return (
    <Typography
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      не найдено
    </Typography>
  );
}

function InputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}
function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent:InputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      variant="standard"
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (<Tooltip title={props.children} placement="bottom">
    <MenuItem
      selected={props.isFocused}
      component="div"
      className={classNames({ [props.selectProps.classes.singleValueDisabled]: props.isDisabled, })}
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem></Tooltip>
  );
}

function Placeholder(props) {
  return <Typography className={props.selectProps.classes.placeholder}>{props.children}</Typography>
}

function SingleValue(props) {
  return <Typography className={props.selectProps.classes.singleValue}>{props.children}</Typography>;
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function Menu(props) {
  return <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>{props.children}</Paper>;
}
const ClearIndicator = (props) => {
  const {
    children = <ClearIcon fontSize="small" />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={{ ...getStyles('clearIndicator', props), padding: 0 }}
    >
      <div style={{ padding: '0px 5px' }}>{children}</div>
    </div>
  );
};

export const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
  DropdownIndicator: null,
  ClearIndicator
};
export const useStyle = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 'auto',
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
    color: theme.palette.text.secondary,
  },
  singleValue: {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
    lineHeight: '1.1876em',
    padding: `6px 0 7px`,
  },
  singleValueDisabled: {
    color: 'rgb(94, 108, 132)',
  },
  placeholder: {
    ...theme.typography.body1,
    color: theme.palette.text.secondary,
    lineHeight: '1.1876em',
    padding: `6px 0 7px`,
  },
  paper: {
    position: 'absolute',
    zIndex: 1000,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
}));